export default __webpack_public_path__ + "static/media/oem_icon.742d8f9d.svg";